// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconClock } from '@ni/nimble-components/dist/esm/icons/clock';
import { wrap } from '../utilities/react-wrapper';

export { type IconClock };
export const NimbleIconClock = wrap(IconClock);